import React, { type ReactNode } from 'react';

export const highlightSearchTerm = (
  text: string,
  searchTerm: string
): ReactNode => {
  if (!searchTerm || !text) return text;

  // Escape special regex characters in the search term
  const escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
  const parts = text.split(regex);

  return React.createElement(
    React.Fragment,
    null,
    ...parts.map((part, index) =>
      regex.test(part)
        ? React.createElement(
            'span',
            { key: index, className: 'font-bold' },
            part
          )
        : part
    )
  );
};
